import { pathOr } from 'ramda';

const navigationAutoNextPath = ['surveySettings', 'navigationAutoNext'];

export const autoNextEnabledForSurvey = surveyMetadata =>
  pathOr(true, navigationAutoNextPath, surveyMetadata);
